<template>
    <div>
        <navbar1></navbar1>
        <div class="__hirebg">
            <div class="container">
                <div class="row __hirflx" id="formfl">
                    <div class="col-lg-6 col-md-7 col-sm-12">
                        <p class="__welf1">What tech-talent are you looking for?</p><br>
                        <!-- <p class="__welf2">
                        Want to work with us on a project? Or you're simply just curious
                        about our secret lab or what we might be cooking up next? Well,
                        you're in the right place!
                        </p> -->
                    </div>
                    <div class="col-lg-6 col-md-5 col-sm-12">
                        <div class="__form-wrap ">
                            <form @submit.prevent="processForm()" method="POST" enctype="multipart/form-data">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label for="fullName">Full name</label>

                                            <input
                                            autofocus
                                            type="text"
                                            class="form-control __form-control"
                                            id="fullName"
                                            name="fullName"
                                            data-field="fullName"
                                            v-model="formField.fullName"
                                            placeholder="John Jane Doe"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label for="email">Email</label>

                                            <input
                                            type="email"
                                            class="form-control __form-control"
                                            id="email"
                                            name="email"
                                            data-field="email"
                                            v-model="formField.email"
                                            placeholder="address@yourdomain.com"
                                            />
                                        </div>
                                    </div>
                                
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label for="phoneNumber">Phone number</label>
                                            <input
                                            type="tel"
                                            class="form-control __form-control"
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            data-field="phoneNumber"
                                            v-model="formField.phoneNumber"
                                            placeholder="+234 810 544 8756"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label for="referee">Company name</label>

                                            <input
                                            type="text"
                                            class="form-control __form-control"
                                            id="work-dur"
                                            name="company"
                                            v-model="formField.company"
                                            data-field="general"
                                            placeholder="Enter company name"
                                            required="required"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="form-group">
                                            <label for="day-amt">What tech stacks are you looking to hire?</label>

                                            <div class="multi-select" @click.stop="toggleDropdown" ref="multiSelect">
                                                <div class="selected-tags">
                                                    <span class="tag" v-for="(stack, index) in formField.stack" :key="index">
                                                        {{ getStackLabel(stack) }}
                                                        <span class="remove-tag" @click.stop="removeStack(index)">×</span>
                                                    </span>
                                                    <span v-if="!formField.stack.length" class="placeholder">Select Stacks</span>
                                                </div>
                                                <div class="dropdown-arrow" :class="{ 'open': isDropdownOpen }"> <img src="../assets/img/cheer.svg"/> </div>
                                                <div class="dropdown-options" v-show="isDropdownOpen">
                                                    <div 
                                                        v-for="stack in stacks" 
                                                        :key="stack.value"
                                                        @click.stop="toggleStack(stack)"
                                                        :class="{ 'selected': isStackSelected(stack) }"
                                                    >
                                                        {{ stack.label }}
                                                    </div>
                                                </div>
                                            </div>
                                            <input 
                                                type="hidden" 
                                                name="tech-stacks" 
                                                :value="JSON.stringify(formField.stack)"
                                            >
                                        </div>
                                    </div>
                                    

                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="form-group">
                                            <label for="project-desc">Anything else you want to add?</label>

                                            <textarea
                                                class="form-control __form-controlarea"
                                                id="project-desc"
                                                name="brief"
                                                rows="4"
                                                v-model="formField.desc"
                                                data-field="general"
                                                placeholder="Type here"
                                                required="required"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-2"></div>
                                    <div class="col-lg-6 col-md-6 col-sm-8">
                                        <button type="submit" class="btn btn-block __adjustlink "
                                        >Submit form</button>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-2"></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row __spacet10p">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <div class="__fodisp">
                        <i class="__icon fas fa-cube"></i>
                        <p class="__hidep">Frontend</p>
                    </div>
                    <p class="__hidep1">React Js<br> Angular Js<br> Vue Js<br>Flutter</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <div class="__fodisp">
                        <i class="__icon fas fa-code"></i>
                        <p class="__hidep">Backend</p>
                    </div>
                    
                    <p class="__hidep1">NodeJs<br>PHP<br>Python<br>Kotlin</p>
                </div>
            
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <div class="__fodisp">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">Mobile</p>
                    </div>
                    
                    <p class="__hidep1">Java<br>Swift<br>React Native<br>Flutter</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <div class="__fodisp">
                        <i class="__icon fas fa-mobile-alt"></i>
                        <p class="__hidep">Data Engineering</p>
                    </div>
                    
                    <p class="__hidep1">Python<br>SQL<br>Power BI<br>Tableau</p>
                </div>
            </div>

            <div class="row __flexsmail">
				<div class="__spacet10p"></div>
				<div class="col-lg-6 col-md-6 col-sm-6 __mobidown">
					<div class="__spacet20p"></div>
					<p class="__letu">Let us handle the hiring<br> process for you</p>
					<p class="__letu1">Extend your team by hiring from our pool of topnotch tech talents and experience the best delivery on your projects. We will handle the vetting, interviews for a fee</p>
                    <a href="#formfl" class="btn __genbtn">Extend your Team</a>
				</div>
				<div class="col-lg-6 col-md-6 col-sm-6 __mobiup">
					<div :style="{ backgroundImage: `url(${require('../assets/img/letimg.png')})` }" class="__imgd"></div>
					<!-- <div class="__imgd" style="background:linear-gradient(100deg, rgba(0, 1, 14, 0.5) 50%, rgba(0, 1, 14, 0.5) 50%), url(https://hire.findworka.com/frontend/assets/img/letimg.png);"></div> -->
				</div>
			</div>
            <div class="row">
                <div class="__spacet10p"></div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div :style="{ backgroundImage: `url(${require('../assets/img/want.png')})` }" class="__imgd"></div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="__spacet20p"></div>
                    <p class="__letu">Want to build a product<br> instead?</p>
                    <p class="__letu1">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                    <router-link to="/build" class="btn __genbtn">Start Building</router-link>
                </div>
            </div>
        </div>
        <div class="__spacet10p"></div>
    </div>
</template>

<script>
import navbar1 from "../components/navbar1";
import axios from 'axios'

export default {
  components: { navbar1 },
  data() {
    return {
      formField: {
        fullName: null,
        email: null,
        phoneNumber: null,
        stack: [],
        desc: null,
        company: null,
      },
      isDropdownOpen: false,
      stacks: [
        { value: 'frontend', label: 'Frontend' },
        { value: 'backend', label: 'Backend' },
        { value: 'fullstack', label: 'FullStack' },
        { value: 'devops', label: 'DevOps' },
        { value: 'mobile', label: 'Mobile' },
        { value: 'data', label: 'Data Science' },
        { value: 'ai', label: 'AI/ML' }
      ],
      redirect: true   
    }
  },

  methods: {
    processForm() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.makeFormRequest()
        } else {
          this.$toasted.global.form_validation_error()
        }
      });
    },
    
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    
    toggleStack(stack) {
      const index = this.formField.stack.indexOf(stack.value);
      if (index === -1) {
        this.formField.stack.push(stack.value);
      } else {
        this.formField.stack.splice(index, 1);
      }
    },
    
    isStackSelected(stack) {
      return this.formField.stack.includes(stack.value);
    },
    
    getStackLabel(value) {
      const found = this.stacks.find(s => s.value === value);
      return found ? found.label : value;
    },
    
    removeStack(index) {
      this.formField.stack.splice(index, 1);
    },
    
    handleClickOutside(event) {
      if (this.isDropdownOpen && 
          !this.$refs.multiSelect.contains(event.target) && 
          (!this.$refs.dropdownOptions || !this.$refs.dropdownOptions.contains(event.target))) {
        this.isDropdownOpen = false;
      }
    },
    
    makeFormRequest() {
      let fd = {
        fullName: this.formField.fullName,
        email: this.formField.email,
        phoneNumber: this.formField.phoneNumber,
        stack: this.formField.stack.join(','),
        company: this.formField.company,
        desc: this.formField.desc
      };
      
      axios({
        url: 'https://findworka-api.onrender.com/api/v1/forms/refer',
        headers: {
          "Access-Control-Allow-Origin": "*", 
          "api_key": "qfoudwCWJkPatcztt%bIxcuoMBEGK9tdv2%jz4Jt4y5CYpc2KAUkQXBfdJ0EeqRh5F!MyvyTO7VSdCoWfPd52RpEpB2arBJGVPtR03wXayBrKdWPFS3AdM0LswwGXQHmkMLwGvwJmcEjiOeZhQ2pxLcHaC3DU87B5Wvc8b5629f78a2d03a42cfde3a52c69tyeyhfj"
        },
        'Content-Type': 'application/json',
        method: 'post',
        data: fd
      })
      .then((response) => {
        if (response.data.error) {
          this.$toasted.error(response.data.message[0] || 'Submission failed');
        } else {
          this.$toasted.success(response.data.message || 'Form submitted successfully!');
          // Optional: redirect or other success actions
          // this.$router.push({ name: 'home' });
        }
      })
      .catch(error => {
        this.apiErrorCatcher(error);
        this.$toasted.error('An error occurred while submitting the form');
      })
      .finally(() => this.resetForm());
    },
    
    resetForm() {
      console.log('Resetting the form');
      Object.keys(this.formField).forEach(key => {
        this.formField[key] = key === 'stack' ? [] : '';
      });
    },
    
    apiErrorCatcher(error) {
      console.error('API Error:', error);
      // Add any specific error handling here
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside, true);
  },
  
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }
};
</script>

<style scoped>
.__rowt {
  margin-top: 29%;
}

.__welf {
  line-height: 1.57;
  color: #69d9f5;
  font-family: Gilroy-Bold;
}

.__welf1 {
    font-size: 72px;
    color: #ffffff;
    font-family: Gilroy-Bold;
    line-height: 1.22;
}

.__welf2 {
  font-size: 16px;
  line-height: 1.38;
  color: #ffffff;
}

.__hirflx{
    align-items: center;
    display: flex;
    flex-wrap: wrap;
}

.__adjustlink {
  /* margin: 40px 0 100px; */

  border-radius: 9px !important;
    background-color: #2357bb !important;
  color: #ffffff !important;
  padding: 10px 30px !important;
  transition: all 0.4s ease-in;
  font-family: Gilroy-Bold;
}

.__hirep {
  font-size: 24px;
  line-height: 1.11;
  color: #000000;
  font-family: Gilroy-Heavy;
}

.__hirep1 {
  font-size: 16px;
  line-height: 1.38;
  color: #000000;
}

.__form-wrap {
  background: #ffffffc2;
  border-radius: 1px;
  border-radius: 20px;
  padding: 20px;
  /* margin-top: -65px; */
}

.__hirflex{
    align-items: center;
    display: flex;
    flex-wrap: wrap;
}

.__hirep{
    font-size: 36px;
    line-height: 1.11;
    color: #000000;
    font-family: Gilroy-Heavy;
    margin-top: 6%;
    margin-bottom: 0;
}
.__hirep1{
    font-size: 16px;
    line-height: 1.38;
    color: #000000;
}
.__fodisp{
    display: flex;
    align-items: center;
    margin-top: 30px;
}
.__icon{
    background: rgba(35, 87, 187, 0.05);
    color: #2357bb;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    padding: 14px;
    margin-right: 10px;
    text-align: center;
}

.__hidep{
    font-size: 18px;
    line-height: 1.22;
    color: #000000;
    font-family: Gilroy-Bold;
    margin-top: 10px;
}

.__hidep1{
    font-size: 16px;
    line-height: 2.22;
    color: #000000;
}

.__letu {
    font-size: 36px;
    line-height: 1.11;
    color: rgba(0, 0, 0, 0.85);
    font-family: Gilroy-ExtraBold;
}

.__letu1 {
    font-size: 16px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.65);
}

.__genbtn {
    line-height: 1.29;
    letter-spacing: 0.4px;
    color: #ffffff !important;
    border-radius: 9px;
    background: #0076f3;
    padding: 12px 18px;
}

.__imgd {
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    height: 380px;
    border-radius: 20px;
    margin-top: 10px;
}


/* multiple select */
.multi-select {
  position: relative;
  border: 1px solid #ccc;
  padding: 5px 30px 5px 8px;
  border-radius: 4px;
  cursor: pointer;
  background: #f6f6f6;
  border-radius: 9px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  min-height: 42px;
}

.selected-options {
  min-height: 20px;
}

.selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.tag {
    background: #2357bb;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
}

.remove-tag {
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
}

.remove-tag:hover {
    color: #ffcccc;
}

.placeholder {
    color: #999;
    align-self: center;
}

.dropdown-arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    transition: transform 0.2s;
}

.dropdown-arrow.open {
    transform: translateY(-50%) rotate(180deg);
}


.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  z-index: 1000;
  /* max-height: 200px; */
  pointer-events: auto;
  overflow-y: auto;
  border-radius: 0 0 9px 9px;
  width: 100%;
margin-top: 5px;
}

.dropdown-options div {
  padding: 8px;
}

.dropdown-options div:hover {
  background: #f0f0f0;
}

.dropdown-options div.selected {
  background: #e0e0e0;
  color: #2357bb;
}

/* Ensure the dropdown stays above other elements */
.multi-select, .dropdown-options {
    z-index: 100;
}
/* multiple select end */

/* .__form-wrap {
  background: #fff;
  border-radius: 1px;
  padding: 40px 30px;
  margin-top: -65px;
} */


.__form-wrap .form-group {
  padding-top: 10px;
}

.__form-control, .__form-controlarea {
  border-radius: 9px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #f6f6f6;
  box-shadow: none !important;
}

.__form-control {
  height: 42px;
}

.__form-wrap .__form-control:focus {
  border: 1px solid #2357bb !important;
}

input[type="file"] {
  opacity: 0;
  width: 0.001px;
  height: 0.0001px;
  position: absolute;
  z-index: -1;
}

.filename
{
  font-size: 12px;
}

.cust-file {
  background-color: #f6f6f6;
  display: block;
  cursor: pointer;
  border-radius: 1px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  height: 42px;
  padding: 12px;
  color: rgba(85, 85, 85, 0.75);
  font-weight: normal;
}

.cust-file:hover,
input[type="file"]:focus + label.cust-file {
  border: 1px solid #2357bb;
}

.__wedrbg{
    background: #dce8ff;
    padding: 8% 0 3%;
}

.__wedop{
    font-size: 36px;
    line-height: 1.11;
    color: #000000;
    font-family: Gilroy-Heavy;
}

.__wedop1{
    font-size: 16px;
    line-height: 1.38;
    color: #000000;
}

.__refcard{
    background: #2357bb;
    padding: 25px 40px 60px;
    margin-top: 5%;
}

.__tesimg{
    width: 54px !important;
    height: 54px;
    border-radius: 50%;
}

.__refp{
    font-size: 18px;
    line-height: 1.22;
    color: #ffffff;
    font-family: Gilroy-Bold;
}

.__refp1{
    /* font-size: 16px; */
    line-height: 1.38;
    color: #ffffff;
}

.__icondr{
    background: rgba(35, 87, 187, 0.05);
    color: #ffffff;
    width: 50px;
    height: 50px;
    font-size: 36px;
    border-radius: 50%;
    padding: 15px 9px;
    text-align: center;
}


</style>



// WEBPACK FOOTER //
// src/components/hire.vue